import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { MessageTypesState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: MessageTypesState = {
    messageTypes: [],
    messageTypeItem: undefined
};


export const messageTypes: Module<MessageTypesState,RootState> = {
    state,
    getters,
    actions,
    mutations
};